import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Menu,
  NumberFormatter,
  rem,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  IconCaretDown,
  IconEdit,
  IconFileUpload,
  IconPlus,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { repositoryPos } from "../../../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../../../_base/extension/NotificationExtension";
import { _localization } from "../../../../../../config/location";
import { MessageResponse } from "../../../../../../model/MessageResponse";
import { tblItemByCat } from "../../../../../../model/TblItem";
import {
  tblPromotion,
  tblPromotionItemAddOnCommand,
} from "../../../../../../model/TblPromotion";
import ModalItemAddOnEditDiscount from "../../Modals/ModalItemAddOnEditDiscount";
import ModalDiscountToAll from "../../Modals/ModalItemPrimaryDiscountToAll";
import ModalSearchItems from "../../Modals/SearchItems";

const TableItemAddOnPromotion = ({
  form,
  setDeleteData,
}: {
  form: UseFormReturnType<tblPromotion, (values: tblPromotion) => tblPromotion>;
  setDeleteData: any;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [keySearch, setKeySearch] = useState<string>("");
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [data, setData] = useState<tblPromotionItemAddOnCommand[]>([]);
  const [dataTemp, setDataTemp] = useState<tblPromotionItemAddOnCommand[]>([]);

  const entity: tblPromotionItemAddOnCommand = {
    id: 0,
    promoteId: null,
    promoteDetailId: null,
    idItemPrimary: null,
    idItemAddOn: null,
    quantityApply: null,
    quantityMin: null,
    quantityMax: null,
    discountPercent: null,
    discountAmount: null,
    priceMin: null,
    priceMax: null,
    // attribute1: null,
    // attribute2: null,
    // attribute3: null,
    // attribute4: null,
    // attribute5: null,
    // attribute6: null,
    // attribute7: null,
    // attribute8: null,
    // attribute9: null,
    // attribute10: null,
    // attribute11: null,
    // attribute12: null,
    // attribute13: null,
    // attribute14: null,
    // attribute15: null,
    itemAddOnCode: null,
    itemAddOnName: null,
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      //   {
      //     accessorKey: "apply",
      //     header: "Áp dụng cho",
      //     size: 20,
      //   },
      {
        accessorKey: "itemAddOnCode",
        header: "Mã hàng",
        size: 129,
      },
      {
        accessorKey: "itemAddOnName",
        header: "Tên hàng",
        size: 500,
        Cell: ({ renderedCellValue, cell }) => (
          <Tooltip label={renderedCellValue as string}>
            <Text truncate="end" w={500}>
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "discountPercent",
        header: "% chiết khấu",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue, cell }) =>
          `${renderedCellValue !== null ? renderedCellValue + "%" : ""}`,
      },
      {
        accessorKey: "discountAmount",
        header: "Số tiền chiết khấu",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "quantityApply",
        header: "SL áp dụng",
        enableGlobalFilter: false,
      },
      {
        accessorKey: "quantityMin",
        header: "SL tối thiểu 1 lần phải mua/1 Đ.Hàng",
        enableGlobalFilter: false,
      },
      {
        accessorKey: "quantityMax",
        header: "SLượng tối đa 1 lần được mua/1 Đ.Hàng",
        enableGlobalFilter: false,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnActions: false,
        enableGlobalFilter: false,
        enableSorting: false,
        size: 100,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {processTaskActionMenu(row)}
          </Box>
        ),
      },
    ],
    []
  );

  function processTaskActionMenu(row: MRT_Row<any>): any {
    return (
      <>
        <Tooltip label="Sửa chiết khấu">
          <ActionIcon variant="light" aria-label="Settings" color="yellow">
            <IconEdit
              size={14}
              stroke={1.5}
              onClick={() => openModalItemAddOnEditDiscount(row.original)}
            />
          </ActionIcon>
        </Tooltip>
        {/* <Tooltip label="Xem chi tiết chiết khấu">
          <ActionIcon variant="light" aria-label="Settings" color="cyan">
            <IconEye
              size={14}
              stroke={1.5}
              //   onClick={}
            />
          </ActionIcon>
        </Tooltip> */}
        <Tooltip label="Xóa sản phẩm">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="red"
            onClick={() => deletesData([row.id])}
          >
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  const openSearchItems = () => {
    modals.openConfirmModal({
      size: "90vw",
      centered: true,
      title: <Title order={5}>Tìm kiếm mặt hàng</Title>,
      children: (
        <ModalSearchItems
          handleAddSearchItem={handleAddSearchItem}
          typeAdd={1}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openModalDiscountToAll = () => {
    modals.openConfirmModal({
      size: "600",
      title: <Title order={5}>Nhập chiết khấu</Title>,
      children: (
        <ModalDiscountToAll
          appleDiscountToAll={appleDiscountToAll}
          itemType="addOn"
          typePromotion="1"
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openModalItemAddOnEditDiscount = (
    dataEdit: tblPromotionItemAddOnCommand
  ) => {
    modals.openConfirmModal({
      size: "600",
      title: <Title order={5}>Nhập chiết khấu</Title>,
      children: (
        <ModalItemAddOnEditDiscount
          dataEdit={dataEdit}
          editItemDiscount={editItemDiscount}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const mapSegments = (array: { code: string; type: number }[]) => {
    const segments: { [key: string]: string[] } = {
      segment1: [],
      segment2: [],
      segment3: [],
      segment4: [],
      segment5: [],
      segment6: [],
    };

    array?.forEach((item) => {
      const segmentKey = `segment${item?.type}`;

      if (segments[segmentKey]) {
        segments[segmentKey].push(item?.code);
      }
    });

    return segments;
  };

  const handleAddItem = async (
    selectedCatSegment: { code: string; type: number }[],
    selectedManuFacTurer: string[],
    selectCat: string | null
  ) => {
    let url = `/api/v1/TblPromotion/get-list-item`;

    const dataSegment = selectedCatSegment.filter(
      (item) => item !== null && item !== undefined
    );
    const dataSubmit = {
      keySearch: "",
      sort: "",
      isOrder: true,
      active: true,
      skip: 0,
      take: 1000,
      ...mapSegments(dataSegment),
    };

    const dataApi = await repositoryPos.post<MessageResponse<any[]>>(
      url,
      dataSubmit
    );
    if (dataApi?.success && dataApi.data) {
      if (dataApi?.data?.length < 1) {
        NotificationExtension.Warn("Không có sản phẩm tồn kho !");
        return;
      }
      const newData: tblPromotionItemAddOnCommand[] = dataApi?.data.map(
        (item) => ({
          ...entity,
          idItemPrimary: item.itemId,
          itemPrimaryCode: item.itemCode,
          itemPrimaryName: item.itemName,
        })
      );
      setData(newData);
      setDataTemp(newData);
      setDeleteData((prevData: any) => [...prevData, ...newData]);
      setRowCount(dataApi?.totalCount || 0);
      setSelectIds([]);
      table.resetRowSelection();
      NotificationExtension.Success("Thêm sản phẩm thành công !");
      modals.closeAll();
    } else {
      setData([]);
      setDataTemp([]);
      setSelectIds([]);
      table.resetRowSelection();
    }
  };

  const handleAddSearchItem = (selectItem: tblItemByCat[]) => {
    const newData: tblPromotionItemAddOnCommand[] = selectItem?.map((item) => ({
      ...entity,
      idItemAddOn: item.itemId,
      itemAddOnCode: item.itemCode,
      itemAddOnName: item.itemName,
      brandId: item.brandId ?? 0,
      isOnhand: item.isOnhand,
      itemShortName: item?.itemShortName?.toString() ?? "",
      segmentId: item.segmentId ?? 0,
      segmentName: item.segmentName?.toString() ?? "",
      quantityMin: item.quantityMin,
      quantityMax: item.quantityMax,
      quantityApply: item.quantityApply,
      discountPercent: item.discountPercent,
      discountAmount: item.discountAmount,
      priceMin: item.quantityMin,
      priceMax: item.quantityMax,
    }));

    const addUniqueItems = (prevData: tblPromotionItemAddOnCommand[]) => {
      const uniqueItemsMap = new Map<number, tblPromotionItemAddOnCommand>();

      [...newData, ...prevData].forEach((item) => {
        if (item.idItemAddOn !== null) {
          uniqueItemsMap.set(item.idItemAddOn, item);
        }
      });
      return Array.from(uniqueItemsMap.values());
    };

    setData((prevData) => addUniqueItems(prevData));
    setDataTemp((prevData) => addUniqueItems(prevData));
    setRowCount((prevData) => prevData + selectItem.length);
    setSelectIds([]);
    table.resetRowSelection();
    modals.closeAll();
  };

  const handleChangeSearch = (e: any) => {
    const value = e.target.value?.trim() ?? "";
    setKeySearch(value);
    if (value) {
      const searchResult = dataTemp.filter(
        (product) =>
          product.itemAddOnCode?.toLowerCase().includes(value) ||
          product.itemAddOnName?.toLowerCase().includes(value)
      );
      setRowCount(searchResult.length);
      setSelectIds([]);
      table.resetRowSelection();
      setData(searchResult);
    } else {
      setRowCount(dataTemp.length);
      setData(dataTemp);
      setSelectIds([]);
      table.resetRowSelection();
    }
  };

  const appleDiscountToAll = (dataSubmit: {
    discountPercent: null;
    discountAmount: null;
    quantityMin: null;
    quantityMax: null;
  }) => {
    // setDataTemp((prevData) =>
    //   prevData.map((item) => ({ ...item, ...dataSubmit }))
    // );
    // setData((prevData) => prevData.map((item) => ({ ...item, ...dataSubmit })));
    const select = table.getSelectedRowModel().rows.map((row) => row.original);
    if (select.length > 0) {
      setDataTemp((prevData) =>
        prevData.map((item) => {
          const selectedItem = select.find(
            (selected) => selected.itemAddOnCode === item.itemAddOnCode
          );
          return selectedItem ? { ...item, ...dataSubmit } : item;
        })
      );
      setData((prevData) =>
        prevData.map((item) => {
          const selectedItem = select.find(
            (selected) => selected.itemAddOnCode === item.itemAddOnCode
          );

          return selectedItem ? { ...item, ...dataSubmit } : item;
        })
      );
    } else {
      setDataTemp((prevData) =>
        prevData.map((item) => ({ ...item, ...dataSubmit }))
      );
      setData((prevData) =>
        prevData.map((item) => ({ ...item, ...dataSubmit }))
      );
    }
    resetRowSelection();
    modals.closeAll();
  };
  const resetRowSelection = () => {
    table.resetRowSelection();
  };
  const editItemDiscount = (dataSubmit: tblPromotionItemAddOnCommand) => {
    setDataTemp((prevData) =>
      prevData.map((item) =>
        item.idItemAddOn === dataSubmit.idItemAddOn
          ? (dataSubmit as tblPromotionItemAddOnCommand)
          : item
      )
    );
    setData((prevData) =>
      prevData.map((item) =>
        item.idItemAddOn === dataSubmit.idItemAddOn
          ? (dataSubmit as tblPromotionItemAddOnCommand)
          : item
      )
    );

    modals.closeAll();
  };

  const deletesData = (ids: string[]) => {
    setDataTemp((prevData) =>
      prevData.filter(
        (item) => !ids.includes(item?.itemAddOnCode?.toString() || "")
      )
    );
    setData((prevData) =>
      prevData.filter(
        (item) => !ids.includes(item?.itemAddOnCode?.toString() || "")
      )
    );
    setSelectIds([]);
    table.resetRowSelection();
  };

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (465 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    form.setFieldValue("tblPromotionItemAddOnCommands", dataTemp);
  }, [dataTemp]);

  // console.log(data, "xóa dữ liệu");

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef}>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Box></Box>
          {/* <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              // await fetchData();
            }}
          >
            Lọc bảng giá
          </Button> */}
        </Flex>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify={"flex-end"}
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Button
            leftSection={<IconPlus size={14} />}
            color="blue"
            variant="outline"
            onClick={openSearchItems}
          >
            Thêm mới (F11)
          </Button>

          <Button
            leftSection={<IconTrash size={14} />}
            color="red"
            variant="outline"
            onClick={() => {
              // const ids = table
              //   .getSelectedRowModel()
              //   .rows.map((row) => row.original.itemPrimaryCode ?? "");
              deletesData(selectIds);
            }}
            disabled={selectIds.length < 1}
          >
            Xóa (đã chọn)
          </Button>

          <Button
            leftSection={<IconEdit size={14} />}
            color="green"
            variant="outline"
            onClick={() => openModalDiscountToAll()}
            disabled={data.length === 0}
          >
            Thiết lập chiết khấu
          </Button>

          <Menu shadow="md">
            <Menu.Target>
              <Button
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Label>Dữ liệu</Menu.Label>
              <Tooltip label="Chức năng đang cập nhật">
                <Menu.Item
                  leftSection={
                    <IconFileUpload
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Import Excel
                </Menu.Item>
              </Tooltip>
            </Menu.Dropdown>
          </Menu>
        </Flex>
      </>
    ),
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    enableBatchRowSelection: true,
    enablePagination: true,
    selectAllMode: "all",
    // rowVirtualizerOptions: { overscan: 8 },
    getRowId: (row) => row?.itemAddOnCode?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: [
          "mrt-row-select",
          "apply",
          "itemAddOnCode",
          "namePurchase",
          "nameManufacturer",
        ],
        right: ["allocationRate", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      showGlobalFilter: true,
    },
    enableGlobalFilter: true,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    // manualPagination: true,
    // manualSorting: true,
    // rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        // fontWeight: "bold",
        fontSize: "11px",
        padding: "4px 12px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      // showProgressBars: isRefetching,
      // showSkeletons: isLoading, //loading for the first time with no data
      //   sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: false,
    mantineTableProps: {
      striped: false,
    },
  });

  return <MantineReactTable table={table} />;
};

export default TableItemAddOnPromotion;
